import { Component, Input, OnChanges } from "@angular/core";
import { ItemStatus } from "src/services/item/item.interface";
import { ItemStatusDisplay } from "src/services/item/item-display";

@Component({
  selector: "rc-item-status-badge",
  templateUrl: "./item-status-badge.component.html",
  styleUrls: ["./item-status-badge.component.scss"],
  standalone: false,
})
export class ItemStatusBadgeComponent implements OnChanges {
  @Input() public itemStatus: ItemStatus;

  public color: string;
  public label: string;

  constructor() {}

  public ngOnChanges() {
    this.label = this.itemStatus ? ItemStatusDisplay[this.itemStatus] : "No status";

    switch (this.itemStatus) {
      case "inStaging":
        this.color = "teal";
        break;
      case "inStorage":
        this.color = "gray";
        break;
      case "inVehicle":
      case "inTrip":
        this.color = "purple";
        break;
      case "onboarding":
        this.color = "orange";
        break;
      default:
        this.color = "warning";
        break;
    }
  }
}
